import api from "@/libs/axios";
import { hasError } from "@/utils/utils";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    volunteers: [],
    loading: false,
    pagination: {
      total_row: 1,
      last_page: 1,
    },
  }),

  getters: {
    volunteers(state) {
      return state.volunteers;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
  },

  mutations: {
    setVolunteers(state, payload) {
      state.volunteers = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },

  actions: {
    async getVolunteers({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.get(ep.VOLUNTEERS, { params: { ...payload } });
        if (hasError(res.status)) throw res.status;
        commit("setVolunteers", res.data.data);
      } catch (err) {
        console.log(err);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
